<template>
  <div class='delayIn'>
    <mt-popup v-model="bshow"
              class='guestInfo-delay'
              popup-transition="popup-fade">
      <div class='delayIn-main'>
        <h2>{{$t('delayIn_Title')}}</h2>
        <div class="guestSwiper">
          <div class="line">
            <p>{{$t('delayIn_newEndDate')}}：</p>
            <Datepicker ref="datepick"
                        @input="dpselect"
                        v-model="req.newDate"
                        class="picker picker-range"
                        :min="start"
                        :max="end"
                        :range="false"></Datepicker>
          </div>
          <div class="line">
            <p>{{$t('delayIn_days')}}：</p>
            <inputNumber ref="rmnum"
                         @input="rmnumChange"
                         v-model='days'
                         :max='999'
                         :min='1'></inputNumber>
          </div>
        </div>
        <div class="btn">
          <div class="unSure"
               @click="bshow=false">{{$t('cancel')}}
          </div>
          <div class="sure"
               @click="save">{{$t('determine')}}
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
  import Datepicker from "../../../common/Datepicker";
  import inputNumber from "../../../common/inputNumber";
  import moment from "moment";

  export default {
    data() {
      return {
        start: moment().format("YYYY-MM-DD"),
        end: moment()
          .add(6, "M")
          .format("YYYY-MM-DD"),
        bshow: false,
        bfirst: false,
        days: 1,
        req: {
          id: null,
          newDate: null,
          newTime: null
        },
        masterBase: null,
        weekarr: []
      };
    },
    props: {},
    mounted() {
      this.weekarr = [
        this.$t('Sunday'),
        this.$t('Monday'),
        this.$t('Tuesday'),
        this.$t('Wednesday'),
        this.$t('Thursday'),
        this.$t('Friday'),
        this.$t('Saturday')
      ];
    },
    methods: {
      show(m) {
        this.bshow = true;
        this.bfirst = true;
        this.masterBase = m.masterBase;
        this.req.id = m.masterBase.id;
        this.req.newTime = m.masterBase.dep.substring(11);
        this.start = moment(m.masterBase.dep)
          .add(1, "d")
          .format("YYYY-MM-DD");
        this.req.newDate = this.start;
        this.setdpDate(this.req.newDate);
        this.days = 1;
        this.$refs.rmnum.updateValue(this.days);
      },
      rmnumChange() {
        this.req.newDate = moment(this.start)
          .add(this.days - 1, "d")
          .format("YYYY-MM-DD");
        this.setdpDate(this.req.newDate);
      },
      setdpDate(v) {
        this.$refs.datepick.setValue(v + " " + this.week(v));
      },
      week(value) {
        return this.weekarr[moment(value).day()];
      },
      dpselect(v) {
        if (this.masterBase != null) {
          this.req.newDate = v;
          this.days = moment(v).diff(moment(this.start), "days") + 1;
          this.$refs.rmnum.updateValue(this.days);
          this.setdpDate(v);
        }
      },
      save() {
        this.confirm2(this.$t('delayIn_confirm') + this.req.newDate + "?", action => {
          this.$http
            .post("/mobilepmsapi/reception/updateMasterDep", this.req)
            .then(res => {
              if (res.data.result == 0) {
                this.msg2(this.$t('delayIn_success')); // 续住成功
                this.bshow = false;
                this.$emit("success");
              } else {
                this.msg2(res.data.msg);
              }
            });
        })
      },
    },
    components: {
      Datepicker,
      inputNumber
    }
  };
</script>

<style lang='less'>
  .delayIn {

    .guestInfo-delay {
      width: 100%;
      height: 300px;
      position: absolute;
      margin: 0 auto;
      padding: 0 15px;
      box-sizing: border-box;
      background: none;

      .delayIn-main {
        background: #fff;
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        border-radius: 10px;
      }

      h2 {
        font-size: 18px;
        color: #666666;
        text-align: center;
        font-style: normal;
        padding: 15px 0;
      }

      .mint-cell-title {
        width: 80px;
      }

      .guestSwiper {
        padding: 0 0.5rem 1.2rem;

        .line {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 0.7rem;

          p {
            font-size: 15px;
            flex: 1;
          }

          .date-picker {
            .input-wrapper {
              width: 4.2rem;
            }

            .dinp {
              padding-left: 0;
            }
          }

          .inputNumber {
            width: 4.2rem;
            box-sizing: border-box;
            overflow: hidden;
            border-color: #cccccc;

            .el-p, .el-j {
              border-color: #cccccc;
            }
          }
        }
      }

      .btn {
        height: 55px;
        border-top: 1px solid #bdbdbd;
        text-align: center;
        font-size: 16px;
        width: 100%;

        .unSure {
          border-right: 1px solid #bdbdbd;
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
        }

        .sure {
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
          color: #5190c3;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// delayIn.vue?3cdc07eb